import {Component} from 'substance'

/**
 * @typedef Component.Notification.Props
 * @property {function} hideNotification
 * @property {Component.NotificationListComponent.Notification} notification
 */

/**
 * @typedef Component.Notification.State
 * @property {?number} visible=null - Visibility value: null, 0, 1, or 2
 */

/**
 * A Notification component
 * @memberof Component
 *
 * @param {Component.Notification.Props} props
 * @property {Component.Notification.Props} props
 * @property {Component.Notification.State} state
 */
class NotificationComponent extends Component {
    getInitialState() {
        return {
            visible: null
        }
    }

    didMount() {
        this.setState({visible: 0});
    }


    updateState(visibleValue) {
        this.props.hideNotification(this.props.notification)
        this.setState({
            visible: visibleValue
        })
    }

    render($$) {
        const outer = $$('div').ref('outer')
        if (this.state.visible === 2) {
            outer.addClass('imc-disposed')
        }

        if (this.props.notification.sticky) {
            outer.append(
                $$('a')
                    .addClass('imc-close')
                    .on('click', () => {
                        this.refs['outer'].el.addClass('imc-hidden')
                        setTimeout(() => {
                            this.refs['outer'].el.addClass('imc-disposed')
                            this.updateState(2)
                        }, 1000)
                    })
            )
        }

        const inner = $$('div').addClass('imc-notification');
        if (this.props.notification.title) {
            inner.append(
                $$('strong').append(this.props.notification.title)
            )
        }

        inner.append(
            $$('span').append(
                this.props.notification.message
            )
        )

        if (0 === this.state.visible) {

            outer.addClass('imc-visible')

            if (!this.props.notification.sticky) {
                setTimeout(() => {
                    this.refs['outer'].el.addClass('imc-hidden')
                    setTimeout(() => {
                        this.refs['outer'].el.addClass('imc-disposed')
                        this.updateState(2)
                    }, 1000)
                }, 5500)
            }
        }
        else {
            outer.addClass('imc-init');
        }

        return outer.append(inner);
    }
}

export {NotificationComponent}
